<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-toolbar>
          <v-icon color="indigo">all_inbox</v-icon>
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Auditoría de Legajo Físico</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <app-impresion-formulario
            :creditoId="solicitud.id"
            :empresaId="solicitud.empresaId"></app-impresion-formulario>

          <v-btn icon @click.stop="hideActiveSubTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-row no-gutters>
          <span class="subtitle-1">Log de Estados</span>
        </v-row>
        <v-row no-gutters>
          <v-data-table
            :headers="headers"
            :items="solicitud.logEstadoLegajoFisico"
            :loading="loading"
            hide-default-footer
            dense>
            <template v-slot:no-data>
              <v-alert
                dense
                :value="true"
                color="grey lighten-3"
                icon="warning">
                No se encontraron datos
              </v-alert>
            </template>

            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  {{
                    item.fecha | dateParse() | dateFormat("DD-MM-YYYY HH:mm")
                  }}
                </td>
                <td class="text-xs-left caption" colspan="2">
                  <tr>
                    <td class="text-uppercase font-weight-medium caption">
                      {{ item.estadoDescripcion }} por {{ item.responsable }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colspan="2"
                      v-if="item.comentarios && item.comentarios != ''"
                      class="font-weight-light caption">
                      {{ item.comentarios }}
                    </td>
                  </tr>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-row>

        <v-row no-gutters>
          <span class="subtitle-1">&nbsp;</span>
        </v-row>

        <v-row no-gutters>
          <span class="subtitle-1 font-weight-black">Modificar Estado</span>
        </v-row>

        <v-row align="center">
          <v-col cols="8">
            <v-autocomplete
              v-model="model.nuevoEstadoId"
              :items="listEstados"
              :disabled="!model.estadoModificado"
              item-text="descripcion"
              item-value="id"
              label="Cambiar a"
              placeholder="Próximo Estado"
              :menu-props="{ minWidth: '200' }"></v-autocomplete>
          </v-col>
          <v-switch
            v-model="model.estadoModificado"
            label="Modificar"></v-switch>
        </v-row>

        <v-row align="center">
          <v-col cols="8">
            <v-autocomplete
              v-model="model.comentarioAdicional"
              :items="listComentarios"
              :disabled="!model.estadoModificado"
              item-text="descripcion"
              item-value="id"
              label="Comentarios Adicionales"
              placeholder="Comentario Adicional"
              :menu-props="{ minWidth: '200' }"></v-autocomplete>
          </v-col>
          <!-- <v-switch
            v-model="model.estadoModificado"
            label="Modificar"></v-switch> -->
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              v-if="requiereNumeroDeCaja || model.numeroCajaLegajo > 0"
              :disabled="
                !checkCanAccess('ap-mod-caja-archivo') && !requiereNumeroDeCaja
              "
              v-model="model.numeroCajaLegajo"
              label="Nº Caja Legajo"></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-if="requiereNumeroDeCaja || model.numeroCajaPagare > 0"
              :disabled="
                !checkCanAccess('ap-mod-caja-archivo') && !requiereNumeroDeCaja
              "
              v-model="model.numeroCajaPagare"
              label="Nº Caja Pagaré"></v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-switch
              v-model="model.carpetaFideicomisoRealizada"
              label="Carpeta Fideicomiso Realizada">
            </v-switch>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-text-field
              v-model="model.comentarios"
              label="Comentarios"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hideActiveSubTask"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="green" dark @click.stop="save">Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";
import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    headers: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: 140 },
      { text: "Estado", value: "estadoDescripcion" },
    ],
    listEstados: [],
    listComentarios: [],
    solicitud: {},
    model: {
      nuevoEstadoId: 1,
      comentarios: null,
      estadoActualId: 0,
      carpetaFideicomisoRealizada: false,
      estadoModificado: false,
      numeroCajaLegajo: 0,
      numeroCajaPagare: 0,
      comentarioAdicional: 0,
    },
    datosAdicionales: {},
  }),
  props: {
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    creditoId: {
      type: String,
      required: false,
    },
  },
  watch: {},
  computed: {
    ...mapGetters(["checkCanAccess"]),
    requiereNumeroDeCaja: function () {
      if (this.model.nuevoEstadoId) {
        var res = this.listEstados.filter(
          (i) => i.id == this.model.nuevoEstadoId
        );

        if (res && res.length > 0) return res[0].requiereNumeroDeCaja;
      }
      return false;
    },
  },
  created() {
    this.loadEstados();

    if (this.creditoId) {
      this.loadDatos();
      this.loadDatosAdicionales();
      this.loadCOmentarios();
    }
  },
  methods: {
    ...mapMutations([
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async loadEstados() {
      this.loading = true;
      try {
        var result = await http.get("tiposestadolegajofisico"); // traigo todas
        this.listEstados = result.list;

        // elimino el elemento 'Intermedio' de la lista
        this.listEstados.splice(4, 1);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadCOmentarios() {
      this.loading = true;
      try {
        var result = await http.get("tiposcomentarioAdicional"); // traigo todas
        this.listComentarios = result.list;

        // elimino el elemento 'Intermedio' de la lista
        this.listComentarios.splice(4, 1);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadDatos() {
      this.loading = true;
      try {
        var result = await http.get(
          "Creditos/getinfosolicitudparaanalisis?id=" + this.creditoId
        );

        this.solicitud = result;

        if (this.solicitud.logEstadoLegajoFisico.length > 0) {
          this.model.estadoActualId =
            this.solicitud.logEstadoLegajoFisico[0].estadoId;
          this.model.nuevoEstadoId =
            this.solicitud.logEstadoLegajoFisico[0].estadoId + 1;
        } else {
          this.model.estadoActualId = 0;
          this.model.nuevoEstadoId = 1;
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDatosAdicionales() {
      this.loading = true;
      try {
        var result = await http.get(
          "creditos/datosadicionales?creditoId=" + this.creditoId
        );
        this.datosAdicionales = result;

        this.model.carpetaFideicomisoRealizada =
          this.datosAdicionales.carpetaFideicomisoRealizada;
        this.model.numeroCajaLegajo = this.datosAdicionales.numeroCajaLegajo;
        this.model.numeroCajaPagare = this.datosAdicionales.numeroCajaPagare;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async save() {
      if (this.model.nuevoEstadoId > 4 && this.model.estadoModificado) {
        this.alertWarning("Por favor, seleccione un estado de la lista.");
        return;
      }

      if (
        this.model.carpetaFideicomisoRealizada ==
          this.datosAdicionales.carpetaFideicomisoRealizada &&
        !this.model.estadoModificado
      ) {
        this.alertWarning("No se detectaron cambios a realizar.");
        return;
      }

      this.loading = true;
      try {
        this.model.creditoId = this.solicitud.id;

        await http.post(
          "creditos/updatelegajofisico",
          JSON.stringify(this.model)
        );
        this.alertSuccess("Los cambios han sido registrados");

        // recargo
        this.loadDatos();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
